import { Injectable } from '@angular/core';
import { StateUtils } from '@spartacus/core';
import { BonusAvailable } from '@user/const';
import { LoyaltyProgramFacade } from '@user/data-access';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoyaltyProgramService {
  constructor(private loyaltyProgramFacade: LoyaltyProgramFacade) {}

  getBonusBalance(): Observable<BonusAvailable> {
    return this.loyaltyProgramFacade.getBonusBalance();
  }

  loadBonusBalance(): void {
    return this.loyaltyProgramFacade.loadBonusBalance();
  }

  loadIfNeedBonusBalance(): Observable<StateUtils.LoaderState<BonusAvailable>> {
    return this.loyaltyProgramFacade.loadIfNeedBonusBalance();
  }

  joinLoyaltyProgram(): void {
    return this.loyaltyProgramFacade.joinLoyaltyProgram();
  }

  getJoinLoyaltyProgramLoading(): Observable<boolean> {
    return this.loyaltyProgramFacade.getJoinLoyaltyProgramLoading();
  }

  getJoinLoyaltyProgramSuccess(): Observable<boolean> {
    return this.loyaltyProgramFacade.getJoinLoyaltyProgramSuccess();
  }

  getIsUserMemberOfLoyaltyProgram(): Observable<boolean> {
    return this.loyaltyProgramFacade.getIsUserMemberOfLoyaltyProgram();
  }

  getIsUserMemberOfLoyaltyProgramLoading(): Observable<boolean> {
    return this.loyaltyProgramFacade.getIsUserMemberOfLoyaltyProgramLoading();
  }
}
